import React from "react";
import Box from "./Box";
import ButtonPrimary from "./ButtonPrimary";
import { useListingsContext } from "./ListingsContext";
import { DARK } from "../core/constants";

function ProductPagination() {
  const { pageInfo, getPage, loadingProducts } = useListingsContext();

  return (
    <Box display="flex" justifyContent="center" pt={[30, null, 40, null]}>
      {loadingProducts === false && (
        <>
          {pageInfo.hasPrevious && (
            <Box mx="3px">
              <ButtonPrimary
                onClick={() => {
                  getPage(pageInfo.previousPageNumber);
                }}
                theme={DARK}
              >
                Previous
              </ButtonPrimary>
            </Box>
          )}
          {pageInfo.hasNext && (
            <Box mx="3px">
              <ButtonPrimary
                onClick={() => {
                  getPage(pageInfo.nextPageNumber);
                }}
                theme={DARK}
              >
                Next
              </ButtonPrimary>
            </Box>
          )}
        </>
      )}
    </Box>
  );
}

export default ProductPagination;
